import cx from "classnames";
import React, { CSSProperties, LegacyRef, PropsWithChildren } from "react";

import styles from "./Popover.mscss";

export type Placement = "top" | "right" | "bottom" | "left";

interface OwnProps {
    className?: string;
    style?: CSSProperties;
    placement?: Placement;
    containerRef?: LegacyRef<HTMLDivElement>;
    arrowRef?: LegacyRef<HTMLDivElement>;
    arrowStyle?: CSSProperties;
    title?: React.ReactNode;
}

type Props = OwnProps;

export const Popover: React.FunctionComponent<Props> = React.memo(
    ({
        className,
        placement = "right",
        containerRef,
        arrowRef,
        arrowStyle,
        style,
        title,
        children,
    }) => {
        return (
            <div
                className={cx(styles.Popover, styles[`Popover--${placement}`], className)}
                style={style}
                ref={containerRef}
            >
                <div ref={arrowRef} className={styles.Popover__arrow} style={arrowStyle} />
                {title && <h3 className={styles.Popover__title}>{title}</h3>}
                <div className={styles.Popover__inner}>{children}</div>
            </div>
        );
    },
);

Popover.displayName = "Popover";
